
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/points/group-buy/progress/[id]",
      function () {
        return require("private-next-pages/account/points/group-buy/progress/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/points/group-buy/progress/[id]"])
      });
    }
  